<h3 matDialogTitle class="notificacao-titulo" style="background-color: #a6d4f5;">
    {{ notificacao.titulo }}
</h3>
<div mat-dialog-content>
  <div class="notificacao-text">
    <ng-container *ngIf="safeTexto; else plaintext">
      <div [innerHTML]="safeTexto"></div>
    </ng-container>
    <ng-template #plaintext>
      <div [innerHTML]="(notificacao?.texto || '') | nl2br"></div>
    </ng-template>
  </div>

  <!-- Technical Details Section -->
  <div *ngIf="technicalDetails" class="technical-details mt-3" style="border-top: 1px solid #ddd; padding-top: 12px;">
    <h5 style="color: #666; font-weight: 600; margin-bottom: 12px;">
      <mat-icon style="font-size: 18px; vertical-align: middle;">info</mat-icon>
      Detalhes Técnicos
    </h5>
    <table style="font-size: 12px; width: 100%; border-collapse: collapse;">
      <tr *ngIf="technicalDetails.certificado_vencimento" style="border-bottom: 1px solid #eee;">
        <td style="padding: 6px; font-weight: 500; width: 40%;">Vencimento:</td>
        <td style="padding: 6px;">{{ technicalDetails.certificado_vencimento | date:'dd/MM/yyyy HH:mm' }}</td>
      </tr>
      <tr *ngIf="technicalDetails.dias_para_vencer" style="border-bottom: 1px solid #eee;">
        <td style="padding: 6px; font-weight: 500;">Dias para Vencer:</td>
        <td style="padding: 6px;"><strong>{{ technicalDetails.dias_para_vencer }}</strong></td>
      </tr>
      <tr *ngIf="technicalDetails.cnpj" style="border-bottom: 1px solid #eee;">
        <td style="padding: 6px; font-weight: 500;">CNPJ:</td>
        <td style="padding: 6px;">{{ technicalDetails.cnpj }}</td>
      </tr>
      <tr *ngIf="technicalDetails.status" style="border-bottom: 1px solid #eee;">
        <td style="padding: 6px; font-weight: 500;">Status:</td>
        <td style="padding: 6px;">
          <span *ngIf="technicalDetails.status === 'VENCIDO'" style="color: #d32f2f; font-weight: 600;">
            VENCIDO
          </span>
          <span *ngIf="technicalDetails.status === 'EXPIRANDO' || technicalDetails.status === 'EXPIRING'" style="color: #f57c00; font-weight: 600;">
            EXPIRANDO
          </span>
          <span *ngIf="technicalDetails.status === 'VALIDO' || technicalDetails.status === 'VALID'" style="color: #388e3c; font-weight: 600;">
            VÁLIDO
          </span>
          <span *ngIf="!['VENCIDO', 'EXPIRANDO', 'EXPIRING', 'VALIDO', 'VALID'].includes(technicalDetails.status)">
            {{ technicalDetails.status }}
          </span>
        </td>
      </tr>
      <tr *ngIf="technicalDetails.filial_id" style="border-bottom: 1px solid #eee;">
        <td style="padding: 6px; font-weight: 500;">Filial ID:</td>
        <td style="padding: 6px;">{{ technicalDetails.filial_id }}</td>
      </tr>
      <tr *ngIf="technicalDetails.criacao">
        <td style="padding: 6px; font-weight: 500;">Criação:</td>
        <td style="padding: 6px; font-size: 11px; color: #999;">{{ technicalDetails.criacao | date:'dd/MM/yyyy HH:mm' }}</td>
      </tr>
    </table>
  </div>
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-button color="warn" type="button" (click)="close()">
    <mat-icon>close</mat-icon>{{ "CLOSE" | translate }}
  </button>
</div>